//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["col","row"],"GetNumber",{R_:{value:''}},2,0],[["col","row"],"GetFormula",{R_:{strValue:''}},2,0],[["col","row"],"GetString",{R_:{strValue:''}},2,0],[["col","row","formulaStr"],"SetFormula",{},3,0],[["col","row","value"],"SetNumber",{},3,0],[["col","row","strValue"],"SetString",{},3,0],[["row"],"InsertRow",{},1,0],[["row"],"InsertCopiedRow",{},1,0],[["col"],"InsertColumn",{},1,0],[["row"],"DeleteRow",{},1,0],[["col"],"DeleteColumn",{},1,0],[["fromCol","toCol"],"MoveColumn",{},2,0],[["fromCell","tocell"],"MoveCell",{},2,0],[["fromRow","toRow"],"MoveRow",{},2,0]],[]];
SPLM.Tooling.ExcelWorksheet = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ExcelWorksheet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;